module.exports = __webpack_public_path__ + "static/media/Flinks-yellow.6a4c3b3b.png";